import axios from 'axios';
import { storageKeys } from 'constants/storage-keys';
import { getCookie } from 'cookies-next';

const restApi = axios.create({
   baseURL: process.env.REACT_APP_BASE_URL,
   timeout: process.env.REACT_APP_TIMEOUT || 10000,
   headers: {
      'Content-Type': 'application/json',
   },
});
const api = axios.create({
   baseURL: process.env.REACT_APP_BASE_URL,
   timeout: process.env.REACT_APP_TIMEOUT || 10000,
   headers: {
      'Content-Type': 'application/json',
   },
});
restApi.interceptors.request.use(
   async (config) => {
      if (config.method === 'get' || config.data === undefined) {
         config.data = true;
      }
      const newConfig = config;
      let token =
         getCookie(storageKeys.ACCESS_KEY_OUTLET) ||
         localStorage.getItem(storageKeys.ACCESS_KEY_OUTLET);
      if (token) {
         newConfig.headers['X-AUTH-TOKEN'] = token;
      }
      return config;
   },
   (error) => Promise.reject(error),
);
api.interceptors.request.use(
   async (config) => {
      if (config.method === 'get' || config.data === undefined) {
         config.data = true;
      }
      return config;
   },
   (error) => Promise.reject(error),
);

restApi.interceptors.response.use(
   function (response) {
      return response;
   },
   function (error) {
      return Promise.reject(error);
   },
);
api.interceptors.response.use(
   function (response) {
      return response;
   },
   function (error) {
      return Promise.reject(error);
   },
);

export { restApi, api };
